import { useEffect, useState } from "react";
import { TPost } from "../../models/posts.model";
import { TimelineCard } from "./TimelineCard";

export function TimelineD3ChartsTooltip({ post }: { post: TPost }) {
  const [position, setPosition] = useState<{ x: number; y: number }>({
    y: 0,
    x: 0,
  });

  useEffect(() => {
    function onMove(event: any) {
      setPosition({
        x: event.clientX,
        y: event.offsetY,
      });
    }

    window.addEventListener("mousemove", onMove);

    return () => {
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  if (position.y == 0 || position.x == 0) return <></>;

  return (
    <>
      <div
        style={{
          position: "fixed",
          borderRadius: "5px",
          pointerEvents: "none",
          top: position.y + 40,
          left:
            position.x > window.innerWidth - 300
              ? position.x - 350
              : position.x,

          width: "300px",
          zIndex: 105,
          scale: "0.8",
        }}
      >
        <TimelineCard
          card={post}
          interests={{ content: [], limit: 0, offset: 0, total: 0 }}
          allowOptions={false}
        />
      </div>
    </>
  );
}
